export const VoxelPickData = [
    {
        id: "dve_debug_box",
        debug: true,
    },
    {
        id: "dve_light_debug",
        debug: true,
    },
    {
        id: "dve_data_holder",
        debug: true,
    },
    {
        id: "dve_marker_box",
        debug: true,
    },
    {
        id: "dve_dream_stone",
    },
    {
        id: "dve_dream_stone_pillar",
    },
    {
        id: "dve_dream_grass_block",
    },
    {
        id: "dve_dream_lamp",
    },
    {
        id: "dve_dream_stone_slab",
        texture: "dve_dream_stone",
        debug: true,
    },
    {
        id: "dve_dream_log",
    },
    {
        id: "dve_dream_stone_stair",
        texture: "dve_dream_stone",
        debug: true,
    },
    {
        id: "dve_dream_grass",
    },
    {
        id: "dve_dream_vine",
    },
    {
        id: "dve_dream_leaves",
    },
    {
        id: "dve_liquid_dream_ether",
    },
    {
        id: "dve_dread_stone",
    },
    {
        id: "dve_dread_grass",
    },
    {
        id: "dve_dread_lamp",
    },
    {
        id: "dve_dread_stone_pillar",
    },
    {
        id: "dve_liquid_dread_ether",
    },
];
